// language-switcher.component.ts
import {Component, computed, inject, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MenuModule} from 'primeng/menu';
import {ButtonModule} from 'primeng/button';
import {Ripple} from "primeng/ripple";
import {TranslateService} from "../../services/translate.service";
import {RouteDataService} from "../../services/route-data.service";

type Lang = 'en' | 'es';

interface LangItem {
  label: string;
  lang: Lang;
  flag: string; // SVG string
  url: string; // absolute href for crawlability
}

@Component({
  selector: 'homey-language-switcher',
  standalone: true,
  imports: [CommonModule, ButtonModule, MenuModule, Ripple],
  templateUrl: `./language-switcher.component.html`
})
export class LanguageSwitcherComponent {
  protected readonly routeDataService = inject(RouteDataService);
  public readonly translateService = inject(TranslateService);
  public readonly location = input("footer");
  items = computed<LangItem[]>(() => ([
    {
      label: 'English', lang: 'en', url: this.translateService.enUrl(), flag: `us`
    },
    {
      label: 'Español', lang: 'es', url: this.translateService.esUrl(), flag: `mx`
    }
  ]));




}
